import { RouterEffects} from './router.effects';
import { AuthEffects } from './auth.effects';
import { NavigationEffects } from './navigation.effects';
import { ProfileEffects } from './profile.effects';
import { AppEffects } from './app.effects';
import { LookupEffects } from './lookup.effects';
import { BuildingEffects } from './building.effects';
import { RequestEffects } from './request.effects';
import { DashboardEffects } from './dashboard.effects';
export const effects: any[] = [
  RouterEffects,
  AuthEffects,
  NavigationEffects,
  ProfileEffects,
  AppEffects,
  LookupEffects,
  BuildingEffects,
  RequestEffects,
  DashboardEffects
];


export * from './router.effects';
export * from './auth.effects';
export * from './navigation.effects';
export * from './profile.effects';
export * from './app.effects';
export * from './lookup.effects';
export * from './building.effects';



// WEBPACK FOOTER //
// ./src/app/core/store/effects/index.ts